import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';

import { JoinRoutingModule } from './join-routing.module';
import { JoinComponent } from './join/join.component';
import { SharedPipesModule } from '../core/pipes/shared-pipes.module';
import { DisclaimerModule } from '../core/disclaimer/disclaimer.module';
import { GraphqlClientModule } from '../core/graphql-client/graphql-client.module';
import { DialogsModule } from '../core/dialogs/dialogs.module';

@NgModule({
  declarations: [JoinComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    RecaptchaModule,
    JoinRoutingModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
    MatProgressSpinnerModule,
    SharedPipesModule,
    DisclaimerModule,
    GraphqlClientModule,
    DialogsModule
  ],
  providers: []
})
export class JoinModule {}
